angular.module('zc.commonApi')

.factory 'ProjectCartPrice', ($resource, $q, BaseProjectCrudService) ->
  class ProjectCartPrice extends BaseProjectCrudService

  new ProjectCartPrice(
    $resource
    $q
    '/api/projects/:projectId/cart_prices/:id'
    'cart_price'
    'cart_prices'
  )





// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/cart_price.service.coffee